
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';

const venue = namespace('venue');

@Component
export default class AuditingFilter extends Vue {
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  @venue.State('active') public venue!: Venue;

  public selectedVenue: string = '';

  public mounted() {
    if (!this.venue) {
      this.$startLoading('venue');
    } else {
      this.setDefaultVenue();
    }
  }

  public setDefaultVenue() {
    if (this.venue?._id) {
      this.selectedVenue = this.venue._id || '';
    }
  }

  @Watch('venue')
  public async onVenueChange() {
    if (this.venue && this.venue._id) {
      this.setDefaultVenue();
    }
  }

  @Watch('selectedVenue')
  @Emit('filter')
  public onFilterChange() {
    return { venue: this.selectedVenue };
  }
}
